module.exports = __webpack_public_path__ + "img/IMG_1699_BlackMatted.4b3149c4.jpg";